export class Pessoa {
    ativo: boolean;
    id: number;
    email: string;
    nome: string;
    rg: string;
    rgOrgaoExpedidor: string;
    cpf: string;
    telefone: string;
}

export class PessoaImagem {
    ativo: boolean;
    data: string;
    descricao: string;
    formato: string;
    url: string;
    pessoaId: number;
    id: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/recursos-humanos/pessoas/shared/pessoa.model.ts
 **/